import React from 'react';

import { getAppConfig } from '@services/config';

type EnergyLabelProps = {
    rating?: string;
    onClick?: () => void;
};

export function EnergyLabel({ rating, onClick }: Readonly<EnergyLabelProps>) {
    if (!rating) return null;

    return (
        <button onClick={onClick} className='button-clear' aria-label="Voir l'étiquette énergétique">
            <img
                src={`${getAppConfig().assets.cmsImages.url}/energy-label/${rating.toLowerCase()}.svg`}
                alt={`Classe énergétique : ${rating}`}
                width={80}
                loading='lazy'
            />
        </button>
    );
}
